import { Button, Card, Checkbox, DatePicker, Form, Input, Modal, Radio, Select, Typography } from "antd";
import React from "react";
import "./index.scss";
const { RangePicker } = DatePicker;

export const VoucherConditionModal = ({ visible, onCancel, onSave, initialValues }) => {
  const [form] = Form.useForm();
  const [validType, setValidType] = React.useState("NONE");
  const [showCustomRange, setShowCustomRange] = React.useState(false);
  const [usageStartType, setUsageStartType] = React.useState("event");
  const [usageEndType, setUsageEndType] = React.useState("event");

  React.useEffect(() => {
    if (visible) {
      form.resetFields();
      if (initialValues) {
        form.setFieldsValue(initialValues);
        setValidType(initialValues?.valid?.type || "NONE");
        setShowCustomRange(initialValues?.valid?.customRangeEnabled);
        setUsageStartType(initialValues?.usage?.startType || "event");
        setUsageEndType(initialValues?.usage?.endType || "event");
      } else {
        setValidType("NONE");
        setShowCustomRange(false);
        setUsageStartType("event");
        setUsageEndType("event");
      }
    }
  }, [visible]);

  const handleOk = async () => {
    const values = await form.validateFields();
    values.usage = values.usage || {};
    values.usage.startType = usageStartType;
    values.usage.endType = usageEndType;
    values.valid = values.valid || {};
    values.valid.type = validType;
    values.valid.customRangeEnabled = showCustomRange;
    onSave?.(values);
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      width={720}
      title={
        <Typography.Title level={4} style={{ margin: 0, fontWeight: 700, fontSize: 15 }}>
          Thiết lập điều kiện áp dụng vouchers cho mức ưu đãi
        </Typography.Title>
      }
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Hủy bỏ
        </Button>,
        <Button key="ok" type="primary" onClick={handleOk}>
          Lưu lại
        </Button>,
      ]}
    >
      <div className="voucher-condition-modal">
        <Form form={form} layout="vertical">
          <Card title="Thông tin mã voucher">
            <Form.Item
              name={["voucher", "code"]}
              label={<Typography.Text strong>Mã voucher</Typography.Text>}
              style={{ marginBottom: 8 }}
              required
              rules={[{ required: true, message: "Vui lòng nhập mã voucher" }]}
            >
              <Input placeholder="Nhập mã voucher" maxLength={32} style={{ fontSize: 15, background: "#fff" }} />
            </Form.Item>
          </Card>

          {/* Time row 1: START */}
          <Card title="Thời gian sử dụng vouchers">
            <Form.Item
              label={<Typography.Text strong>Thời gian bắt đầu</Typography.Text>}
              style={{ marginBottom: 10 }}
              required={true}
              validateTrigger={["onChange", "onBlur"]}
              rules={[{ required: true, message: "Bắt buộc chọn thời gian cụ thể" }]}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Radio.Group value={usageStartType} onChange={(e) => setUsageStartType(e.target.value)}>
                  <Radio.Button value="event">Theo thời gian bắt đầu CTKM</Radio.Button>
                  <Radio.Button value="specific">Thời gian cụ thể</Radio.Button>
                </Radio.Group>
                {usageStartType === "specific" && (
                  <Form.Item name={["usage", "start"]} noStyle rules={[{ required: true, message: "Chọn thời gian" }]}>
                    <DatePicker showTime format="HH:mm DD/MM/YYYY" style={{ width: 230, marginLeft: 8 }} />
                  </Form.Item>
                )}
              </div>
            </Form.Item>
            {/* Time row 2: END */}
            <Form.Item
              label={<Typography.Text strong>Thời gian kết thúc</Typography.Text>}
              style={{ marginBottom: 14 }}
              required={true}
              validateTrigger={["onChange", "onBlur"]}
              rules={[{ required: true, message: "Bắt buộc chọn thời gian cụ thể" }]}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Radio.Group value={usageEndType} onChange={(e) => setUsageEndType(e.target.value)}>
                  <Radio.Button value="event">Theo thời gian kết thúc CTKM</Radio.Button>
                  <Radio.Button value="specific">Thời gian cụ thể</Radio.Button>
                </Radio.Group>
                {usageEndType === "specific" && (
                  <Form.Item name={["usage", "end"]} noStyle rules={[{ required: true, message: "Chọn thời gian" }]}>
                    <DatePicker showTime format="HH:mm DD/MM/YYYY" style={{ width: 230, marginLeft: 8 }} />
                  </Form.Item>
                )}
              </div>
            </Form.Item>
          </Card>

          {/* Validity block */}
          <Card title="Thời gian hiệu lực vouchers">
            <Form.Item
              label={<Typography.Text strong>Thời gian hiệu lực</Typography.Text>}
              required={validType === "RULED"}
              validateTrigger={["onChange", "onBlur"]}
              rules={validType === "RULED" ? [{ required: true, message: "Bắt buộc nhập thời gian hiệu lực" }] : []}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Radio.Group value={validType} defaultValue="NONE" onChange={(e) => setValidType(e.target.value)}>
                  <Radio.Button value="RULED">Có quy định</Radio.Button>
                  <Radio.Button value="NONE">Không quy định</Radio.Button>
                </Radio.Group>
                {validType === "RULED" && (
                  <div style={{ marginLeft: 16, width: "160px", display: "flex", alignItems: "center" }}>
                    <Form.Item name={["valid", "duration"]} noStyle initialValue={1}>
                      <Input style={{ width: 60 }} />
                    </Form.Item>
                    <Form.Item name={["valid", "durationUnit"]} noStyle initialValue="MONTH">
                      <Select
                        style={{ width: 90 }}
                        options={[
                          { label: "Tháng", value: "MONTH" },
                          { label: "Ngày", value: "DAY" },
                        ]}
                      />
                    </Form.Item>
                  </div>
                )}
              </div>
            </Form.Item>
            {validType === "RULED" && (
              <div style={{ marginBottom: 18 }}>
                <Checkbox
                  checked={showCustomRange}
                  onChange={(e) => setShowCustomRange(e.target.checked)}
                  style={{ marginBottom: 10 }}
                >
                  Thời gian cụ thể
                </Checkbox>
                {showCustomRange && (
                  <Form.Item name={["valid", "customRange"]}>
                    <RangePicker
                      showTime
                      format="HH:mm DD/MM/YYYY"
                      style={{ width: "100%" }}
                      placeholder={["Thời gian bắt đầu", "Thời gian kết thúc"]}
                    />
                  </Form.Item>
                )}
              </div>
            )}
          </Card>
        </Form>
      </div>
    </Modal>
  );
};

export default VoucherConditionModal;
